import { useQuery } from "@tanstack/react-query";
import { fetchWarehouseItem } from "../../../../../../enums/queryFunction/Fetch";
import { WAREHOUSE_ITEM } from "../../../../../../enums/QueryKeys";

export function useGetWarehouseItem(itemId) {
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: [WAREHOUSE_ITEM, itemId],
    queryFn: () => fetchWarehouseItem(itemId),
    enabled: Boolean(itemId),
  });

  return { data, isLoading, isFetching, error, refetch };
}
